
import GwContentTemplate from '~/patterns/templates/content.vue';
import GwCourseList from '~/patterns/organisms/course-list/course-list.vue';
import getCoursePages from '~/graphql/queries/getCoursePages.graphql';
import seo from '~/mixins/seo';
import getProgramPage from '~/graphql/queries/getProgramPage.graphql';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import GwSection from '~/patterns/organisms/section/section.vue';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro';
import GwError from '~/patterns/molecules/error';

export default {
    components: {
        GwContentTemplate,
        GwCourseList,
        GwPageContainer,
        GwPageTitle,
        GwPageIntro,
        GwSection,
        GwError,
        FlexibleSection,
    },
    mixins: [seo],
    layout: 'overview',
    data() {
        return {
            entry: null,
            coursePages: null,
            notFound: false
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getProgramPage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }

        const coursePages = await this.$gql.executeQuery(
            getCoursePages,
            { site, program: this.$route.params.slug }
        );

        this.coursePages = coursePages.data.entries;
    },
    nuxtI18n: {
        paths: {
            en: '/courses/:slug',
            in: '/courses/:slug',
            nl: '/trainingen/:slug',
            fr: '/formations/:slug',
            de: '/trainings/:slug',
            'en-Highberg': '/courses/:slug',
            'nl-Highberg': '/trainingen/:slug',
            'de-Highberg': '/trainings/:slug',
        }
    }
};
